import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F_Next() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('homebattery');
    const productList = [
        {
            name: t('secH_product1_name'),
            desc: t('secH_product1_desc'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718958783484/product1.png',
            link: 'https://jp.ecoflow.com/products/delta-pro-3-eb-home-distribution-boards',
        },
        {
            name: t('secH_product2_name'),
            desc: t('secH_product2_desc'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718958783666/product2.png',
            link: 'https://jp.ecoflow.com/products/delta-pro-3',
        },
        {
            name: t('secH_product3_name'),
            desc: t('secH_product3_desc'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718958783852/product3.png',
            link: 'https://jp.ecoflow.com/products/delta-pro-3-400w',
        },
    ];

    return (
        <div id="G" className={`home-battery-F_Next home-battery-box ${css['home-battery-F_Next']}`}>
            <h2 className="title">{t('secH_title')}</h2>
            <div className="product-list">
                {productList.map((item, index) => (
                    <div className="product" key={index}>
                        <EFPicture src={item.img} alt={t('secH_title')} />
                        <p className="name">{item.name}</p>
                        <p className="desc">{item.desc}</p>
                        <Link
                            className="btn"
                            href={item.link}
                            aria={item.name}
                            alt={item.name}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: item.name,
                                position: 'Product Preview',
                            }}
                        >
                            {t('secH_btn')}
                        </Link>
                    </div>
                ))}
            </div>
            <Swiper
                className="swiper-box"
                modules={[Navigation, Pagination]}
                spaceBetween={24}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={{ clickable: true }}
            >
                {productList.map((item, index) => (
                    <SwiperSlide className="product" key={index}>
                        <EFPicture src={item.img} alt={t('secH_title')} />
                        <p className="name">{item.name}</p>
                        <p className="desc">{item.desc}</p>
                        <Link
                            className="btn"
                            href={item.link}
                            aria={item.name}
                            alt={item.name}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: item.name,
                                position: 'Product Preview',
                            }}
                        >
                            {t('secH_btn')}
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
